module.exports = __webpack_public_path__ + "img/rem10.3b09b3ec.jpg";